import { getCountryName } from '@quds/shared';
import { cn } from '@/lib/cn';
import { Flag } from './Flag';

export interface CountryDisplayProps {
  country: string;
  /** Optional secondary line (usually city). */
  city?: string | null;
  className?: string;
  flagSize?: number;
  /** Show only the flag + country name on one line. */
  compact?: boolean;
}

/** Flag + country name, optionally with city underneath. */
export function CountryDisplay({ country, city, className, flagSize = 14, compact = false }: CountryDisplayProps) {
  const name = getCountryName(country);
  if (compact) {
    return (
      <span className={cn('inline-flex items-center gap-2', className)}>
        <Flag code={country} size={flagSize} title={name} />
        <span className="truncate text-ink">{name}</span>
      </span>
    );
  }
  return (
    <span className={cn('inline-flex items-start gap-2', className)}>
      <Flag code={country} size={flagSize} title={name} className="mt-0.5" />
      <span className="min-w-0">
        <span className="block truncate text-ink">{name}</span>
        {city ? <span className="block truncate text-xs text-ink-muted">{city}</span> : null}
      </span>
    </span>
  );
}
